import { Deserializer, makeQueryStringSerializer } from 'core/lib/serializer';
import LogoutReason from 'enums/LogoutReason';

interface LogoutQueryParams {
    reason?: LogoutReason;
}

const logoutQuerySerializer = makeQueryStringSerializer<LogoutQueryParams>({}, { reason: Deserializer.Int });
export default logoutQuerySerializer;
